export default __webpack_public_path__ + "static/Entenda0028-39c9a50cd2a0575199c5d85418c93d82.jpg";